import { useEffect, useState } from 'react'
import useLazyQueryApi from '../../../../../hooks/useLazyQuery'
import {
  ADD_NEW_TEST_GROUP,
  ADD_TEST_GROUP,
  DELETE_TEST_GROUP,
  GET_ASSOCIATED_TEST_GROUPS,
  GET_MULTIPLE_TEST_NAME_BY_PRODUCT,
  GET_REMAINING_PRODUCTS_OFFERERD,
  GET_REMAINING_TEST_GROUPS_OFFERED,
  GET_SELECTED_PRODUCTS,
  UPDATE_TEST_GROUP_NAME,
} from '../../GraphQLQueries/ProductOffering'
import useApi from '../../../../../hooks/useQuery'
import clsx from 'clsx'
import useMutationApi from '../../../../../hooks/useMutation'
import { LoadingSpinner } from '../../../../../_ePulse/layout/components/LoadingSpinner'
import { ToastMessageContainer } from '../../../../../_ePulse/layout/components/ToastMessageContainer'
import { toast } from 'react-toastify'
import { UpdateTestGroup } from './modals/updateTestGroupModal'
import { TestTable } from './table/testTable'
import { TestType } from './types/testType'
import { CreateTestGroup } from './modals/createTestGroupModel'

const Product = () => {
  const [modalShow, setModalShow] = useState(0)
  const [field, setfield] = useState<any>(null) // Selected Product
  const [productList, setProductList] = useState<any>([]) // Get Product
  const [testGroupList, setTestGroupList] = useState<any>([]) // Get Test Groups
  const [associatedTestList, setAssociatedTestList] = useState<any>([]) // Get Associated Tests with Test Group
  const [isTabMenu, setIsTabMenu] = useState(true)
  const [currentTest, setCurrentTest] = useState<any>(null)
  const [selectedTestGroup, setSelectedTestGroup] = useState<any>(null) // Selected Test Group for Edit/Delete
  // Current Text for Edit/Delete

  console.log('selectedtestgrpur', selectedTestGroup)
  console.log('associatedTestList', associatedTestList)
  const {
    loading: loadingData,
    error: MedicineError,
    data: productData,
    refetch: refetchList,
  } = useApi('', GET_SELECTED_PRODUCTS, {})

  const {
    loading: loadingProducts,
    error: productError,
    data: products,
    fetchData: refetchData,
  } = useLazyQueryApi('', GET_ASSOCIATED_TEST_GROUPS)

  const {
    loading: loadingAssociatedTest,
    error: associatedTestError,
    data: associatedTestData,
    fetchData: refetchAssociatedTestData,
  } = useLazyQueryApi('', GET_MULTIPLE_TEST_NAME_BY_PRODUCT)

  const { createData, loading, error, data } = useMutationApi(ADD_NEW_TEST_GROUP)

  const {
    createData: AddNewTest,
    loading: addLoading,
    error: addError,
    data: addData,
  } = useMutationApi(ADD_TEST_GROUP)
  const {
    createData: DeleteTestGroup,
    loading: deleteLoading,
    error: deleteError,
    data: deleteData,
  } = useMutationApi(DELETE_TEST_GROUP)
  const {
    createData: updateTestGroup,
    loading: updateTestLaoding,
    error: updateTestError,
    data: updateTestData,
  } = useMutationApi(UPDATE_TEST_GROUP_NAME)

  useEffect(() => {
    if (productData && productData.getBusinessProductOffering) {
      setProductList(productData.getBusinessProductOffering)
      refetchData({ productValue: productData.getBusinessProductOffering[0].productValue })
      setfield(productData.getBusinessProductOffering[0])
    }
  }, [productData])

  useEffect(() => {
    if (products && products.getBusinessProductGroupByProductOffering) {
      setTestGroupList(products.getBusinessProductGroupByProductOffering)
      setSelectedTestGroup(null)
    }
  }, [products])

  useEffect(() => {
    if (associatedTestData?.getBusinessTestByMutlipleTestGroup?.length > 0) {
      const group = associatedTestData.getBusinessTestByMutlipleTestGroup[0]
      const transformed: TestType[] = group.testNames.map((test: any) => ({
        id: test.testId,
        productName: test.testName,
        testGroupName: group.id,
        testName: test.testName,
        testCost: test.price,
        testCode: test.testCode,
        isDelete: test.isDeleted,
        isBusinessCreated: test.isBusinessCreated || false,
      }))
      setAssociatedTestList(transformed)
    } else {
      setAssociatedTestList([])
    }
  }, [associatedTestData])

  const [activeKey, setActiveKey] = useState<any>(null)

  const handleSelect = (eventKey: any) => {
    console.log('eventKey', eventKey)
    const testGroupValue = testGroupList.find((i: any) => i.id === eventKey)?.testGroupValue
    console.log('testGroupName', testGroupValue)
    if (eventKey !== null && testGroupValue) {
      setActiveKey(eventKey) // Set the loadingId to the selected eventKey
      refetchAssociatedTestData({ productGroup: [testGroupValue] })
    }
    setActiveKey(eventKey)
  }

  const handleAddNewTestGroup = async (props: any) => {
    //  {"productGroup": "mri", "testGroupName": "Test102"}

    try {
      console.log('object', props)
      await AddNewTest({ groupInput: props })
      toast.success('Test Group Added Successfully')
      refetchData({ productValue: props.productGroup })
    } catch (e) {
      console.error('Error adding test group:', e)
      toast.error('Failed to add Test Group')
    }
    // setModalShow(0)
  }

  const handleUpdateTestGroup = async (props: any) => {
    try {
      await updateTestGroup(props)
      toast.success('Test Group Updated Successfully')
      console.log('props.groupInput.productGroup........', props.groupInput.productGroup)

      refetchData({ productValue: props.groupInput.productGroup })
    } catch (e) {
      console.error('Error updating test group:', e)
      toast.error('Failed to update Test Group')
    }
    setSelectedTestGroup(null)
  }

  const handleDeleteTestGroup = async (props: any) => {
    try {
      await DeleteTestGroup(props)
      toast.success('Test Group Delete Successfully')
      refetchData({ productValue: field.productValue })
    } catch (e) {
      toast.error('Failed to delete Test Group')
    }
  }

  return (
    <div className='d-flex flex-column form-wrapper'>
      <LoadingSpinner isLoading={loading || loadingProducts} />
      <div>
        <ToastMessageContainer />
      </div>
      {/* {modalShow === 1 && <ProductsModel onClose={() => { setModalShow(0) }} refetch={refetchList} />} */}
      {modalShow === 1 && (
        <CreateTestGroup
          onClose={() => {
            setModalShow(0)
            setSelectedTestGroup(null)
          }}
          field={field}
          handleAddNewTestGroup={handleAddNewTestGroup}
          handleUpdateTestGroup={handleUpdateTestGroup}
          handleDeleteTestGroup={handleDeleteTestGroup}
          selectedTestGroup={selectedTestGroup}
        />
      )}

      {modalShow === 2 && (
        <UpdateTestGroup
          onClose={() => {
            setModalShow(0)
            setSelectedTestGroup(null)
          }}
          handleUpdateTestGroup={handleUpdateTestGroup}
          handleDeleteTestGroup={handleDeleteTestGroup}
          selectedTestGroup={selectedTestGroup}
        />
      )}

      <div className='d-flex justify-content-between align-items-center'>
        <h2 className='page-title'>Product</h2>
      </div>
      <div className='d-flex'>
        {productList.length > 0 ? (
          productList.map((tab: any) => {
            return (
              <button
                key={tab.id}
                className={`tab ${field?.productValue === tab.productValue ? 'active' : ''}`}
                style={
                  field?.productValue === tab.productValue
                    ? {
                      margin: '10px',
                      color: '#fff',
                      textAlign: 'center',
                      padding: '10px 90px',
                      border: 'none',
                      fontWeight: 'bold',
                      backgroundColor: '#bdbdbd',
                    }
                    : {
                      margin: '10px',
                      textAlign: 'center',
                      padding: '10px 90px',
                      border: 'none',
                    }
                }
                onClick={() => {
                  setfield(tab)
                  refetchData({ productValue: tab.productValue })
                  setSelectedTestGroup(null)
                }}
              >
                {tab.productName}
              </button>
            )
          })
        ) : (
          <div></div>
        )}
      </div>
      <hr />
      <div className='vertical-tabs'>
        <div
          className={clsx(
            isTabMenu ? 'tab-list-container col-3' : 'tab-list-container col-2 menuOpen'
          )}
        >
          <div className='tab-list' style={{ height: '400px', overflow: 'hidden auto' }}>
            <button
              // className={`tab ${field?.productValue === tab.productValue ? 'active' : ''}`}
              style={{
                margin: 10,
                height: 'px',
                backgroundColor: '#f0f0f0',
                border: '1px solid #ccc',
              }}
              className='ePulse-btn-primary'
              onClick={() => {
                // handleSelect(null);
                setModalShow(1)
                // refetchData({ productValue: tab.productValue });
                // setvalue(tab.value);
              }}
            >
              {'Add Test Group'}
            </button>
            {testGroupList.length > 0 ? (
              testGroupList.map((tab: any) => {
                return (
                  <div className='d-flex align-items-center' key={tab.id}>
                    <button
                      key={tab.id}
                      className={`tab ${selectedTestGroup?.testGroupLabel === tab.testGroupLabel ? 'active' : ''
                        }`}
                      style={{ width: '100%' }}
                      onClick={() => {
                        setSelectedTestGroup(tab)
                        handleSelect(tab.id)
                        // refetchData({ productValue: tab.productValue });
                        // setvalue(tab.value);
                      }}
                    >
                      {tab.testGroupLabel}
                    </button>
                    {tab.isBusinessCreated && (
                      <button
                        className='ePulse-btn-primary'
                        type='button'
                        onClick={() => {
                          setSelectedTestGroup(tab)
                          setModalShow(2)
                        }}
                      >
                        Edit
                      </button>
                    )}
                  </div>
                )
              })
            ) : (
              <div>No Test Group Added</div>
            )}
          </div>
        </div>
        <div className='tab-content'>
          {selectedTestGroup ? (
            <>
              {loadingAssociatedTest ? (
                'Loading...'
              ) : (

                <TestTable
                  data={associatedTestList}
                  productValue={field.productValue}
                  testGroupValue={selectedTestGroup.testGroupValue}
                  testGroupLabel={selectedTestGroup.testGroupLabel}
                  refetchData={refetchAssociatedTestData}
                />
              )}
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}

export default Product
